import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Grid, Tooltip, IconButton, Snackbar } from '@mui/material';
import { Color } from '../../../assets/color';
import { useNavigate } from 'react-router-dom';
import { DeleteSvg, EditSvg, PersonSvg } from '../../../assets/svg';
import { ContentCopy, OpenInNew } from '@mui/icons-material';
import RouteHeader from '../../../components/common/RouteHeader';
import DatatableHeading from '../../../components/heading/DatatableHeading';
import DatatableWithSearch from '../../../components/datatable/DatatableWithSearch';
import * as AdminActions from '../../../redux/actions/adminAction';

const Partners = ({ label }) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { partnerData, affiliatesData } = useSelector(state => state?.adminReducer);
    const { superadminAdminPartnerDetails } = useSelector((state) => state.authReducer);
    const [copiedSnackbar, setCopiedSnackbar] = useState(false);

    const getPartnerUrl = (row) => {
        const params = new URLSearchParams();
        if (row?.registration_number) params.append('partnerId', row.registration_number);
        if (row?.partner_name) params.append('partnerName', row.partner_name);
        if (row?.company_name) params.append('company', row.company_name);
        return `https://web.irisanalysis.ai/partner?${params.toString()}`;
    };

    //* Datatable Columns
    const columns = [
        { name: 'S.No.', selector: row => label == 'Partner' ? partnerData?.indexOf(row) + 1 : affiliatesData?.indexOf(row) + 1, width: '80px' },
        { name: label === 'Affiliate' ? 'Affiliate Name' : 'Partner Name', selector: row => row?.partner_name || '—', width: '160px' },
        ...(label === 'Affiliate' ? [{ name: 'Partner Name', selector: row => row?.parentPartnerId?.partner_name || '—', width: '160px' }] : []),
        { name: 'Admin', selector: row => row?.adminId?.admin_name || '—', width: '140px' },
        { name: 'Reg.No.', selector: row => <span style={{ textTransform: 'capitalize' }}>{row?.registration_number}</span> },
        {
            name: 'URL',
            cell: row => {
                const url = getPartnerUrl(row);
                return (
                    <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                        <Tooltip title="Copy URL">
                            <IconButton size="small" onClick={() => { navigator.clipboard.writeText(url); setCopiedSnackbar(true); }}>
                                <ContentCopy style={{ fontSize: '16px', color: Color.primary }} />
                            </IconButton>
                        </Tooltip>
                        <Tooltip title="Open URL">
                            <IconButton size="small" onClick={() => window.open(url, '_blank')}>
                                <OpenInNew style={{ fontSize: '16px', color: Color.primary }} />
                            </IconButton>
                        </Tooltip>
                    </div>
                );
            },
            width: '100px'
        },
        { name: 'Mobile No.', selector: row => row?.mobile_number || '...' },
        { name: 'Email ID', selector: row => row?.email || '...', width: '250px' },
        { name: 'Password', selector: row => row?.password || '...' },
        { name: 'Wallet Balance', selector: row => row?.report_wallet_balance || '...' },
        ...(label === 'Partner' ? [{ name: 'Affiliates', selector: row => row?.affiliateCount ?? 0 }] : []),
        { name: 'Status', selector: row => row?.is_active ? 'Active' : 'Inactive' },
        {
            name: 'Action',
            cell: row => (
                <div style={{ display: "flex", gap: "20px", alignItems: "center" }}>
                    <div onClick={() => label === 'Partner'
                            ? navigate(`/management/partners/affiliates?name=${row?.partner_name}&id=${row?._id}`)
                            : navigate(`/management/affiliates/customer?name=${row?.partner_name}&id=${row?.registration_number}`)} style={{ cursor: "pointer" }}><PersonSvg /></div>
                    <div onClick={() => navigate(`/management/${label?.toLowerCase()}s/edit-${label?.toLowerCase()}`, { state: { stateData: row } })} style={{ cursor: "pointer" }}><EditSvg /></div>
                    {/* <div style={{ cursor: "pointer" }}><DeleteSvg /></div> */}
                </div>
            ),
            right: 'true'
        },
    ];

    useEffect(() => {
        //! Dispatching API
        dispatch(AdminActions.getPartners({ label }));
    }, [label]);

    return (
        <>
            <RouteHeader title={`${label}s MIS`} sub_title={`Manage and view ${label?.toLowerCase()}s information`} url={(label === 'Affiliate' ? superadminAdminPartnerDetails?.role === 'Partner' : superadminAdminPartnerDetails?.role === 'Admin') ? `/management/${label?.toLowerCase()}s/add-${label?.toLowerCase()}` : ''} url_name={(label === 'Affiliate' ? superadminAdminPartnerDetails?.role === 'Partner' : superadminAdminPartnerDetails?.role === 'Admin') ? `Add ${label}` : ''} />

            <div style={{ backgroundColor: Color.white, padding: "20px", borderRadius: "10px" }}>
                <Grid container spacing={6} >
                    <Grid item lg={12} md={12} sm={12} xs={12}>
                        <DatatableHeading title={`${label}s Management Information System`} sub_title={`View and manage ${label?.toLowerCase()}s data with filtering options`} />
                    </Grid>

                    <Grid item lg={12} md={12} sm={12} xs={12}>
                        <DatatableWithSearch data={label == 'Partner' ? partnerData : affiliatesData} columns={columns} />
                    </Grid>
                </Grid>
            </div>

            <Snackbar open={copiedSnackbar} autoHideDuration={2000} onClose={() => setCopiedSnackbar(false)} message="URL copied to clipboard!" anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }} />
        </>
    )
}

export default Partners;